import { injectable } from 'inversify';
import type {
  ITenantAdicionalRepository,
  CreateTenantAdicionalData,
  UpdateTenantAdicionalData,
  TenantPlanExtras,
  TenantExtrasSnapshot,
} from '@/domain/repositories/ITenantAdicionalRepository';
import type { TenantAdicionalDTO } from '@/domain/entities/TenantAdicional';
import { httpClient } from '@/infrastructure/http/client/httpClient';

@injectable()
export class ApiTenantAdicionalRepository implements ITenantAdicionalRepository {
  async getByTenantId(tenantId: string): Promise<TenantAdicionalDTO[]> {
    const response = await httpClient.get<TenantAdicionalDTO[]>(
      `/admin/tenants/${tenantId}/adicionales`
    );
    return response.data;
  }

  async create(
    tenantId: string,
    data: CreateTenantAdicionalData
  ): Promise<TenantAdicionalDTO> {
    const response = await httpClient.post<TenantAdicionalDTO>(
      `/admin/tenants/${tenantId}/adicionales`,
      data
    );
    return response.data;
  }

  async update(
    tenantId: string,
    tenantAdicionalId: number,
    data: UpdateTenantAdicionalData
  ): Promise<TenantAdicionalDTO | null> {
    const response = await httpClient.put<TenantAdicionalDTO>(
      `/admin/tenants/${tenantId}/adicionales/${tenantAdicionalId}`,
      data
    );
    return response.data;
  }

  async toggleEstado(
    tenantId: string,
    tenantAdicionalId: number
  ): Promise<TenantAdicionalDTO | null> {
    const response = await httpClient.patch<TenantAdicionalDTO>(
      `/admin/tenants/${tenantId}/adicionales/${tenantAdicionalId}/estado`
    );
    return response.data;
  }

  async setExtras(tenantId: string, extras: TenantPlanExtras): Promise<TenantPlanExtras> {
    const response = await httpClient.put<TenantPlanExtras>(
      `/admin/tenants/${tenantId}/adicionales/extras`,
      extras
    );
    return response.data;
  }

  async getExtrasSnapshot(tenantId: string): Promise<TenantExtrasSnapshot> {
    const response = await httpClient.get<TenantExtrasSnapshot>(
      `/admin/tenants/${tenantId}/adicionales/extras`
    );
    return response.data;
  }

  async syncExtrasFromUsage(tenantId: string): Promise<TenantExtrasSnapshot> {
    const response = await httpClient.put<TenantExtrasSnapshot>(
      `/admin/tenants/${tenantId}/adicionales/extras/sync-usage`
    );
    return response.data;
  }
}
